// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d541d587","455":"466dab05","977":"c7be0865"}[chunkId] + ".chunk.js";
};